export default "__VITE_ASSET__a3bb3baa__"